import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import { useMutation } from "@/hooks/useMutation"
import {
  InviteConsultantMutation,
  InviteConsultantMutationMutation,
  InviteConsultantMutationMutationVariables,
  JobTitle,
} from "@/gql"
import { useNotification } from "@/hooks/useNotification"
import OutlinedTextField from "../fields/OutlinedTextField.vue"
import JobRoleSelect from "@/components/widgets/input/JobRoleSelect.vue"

type InviteConsultantFormValues = {
  firstName: string
  lastName: string
  email: string
  jobTitleId: JobTitle | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InviteConsultantForm',
  emits: ["close"],
  setup(__props, { emit }) {

const defaultFormData: InviteConsultantFormValues = {
  firstName: "",
  lastName: "",
  email: "",
  jobTitleId: null,
}

const formData = ref<InviteConsultantFormValues>({ ...defaultFormData })
const inviteConsultantLoading = ref(false)

const { mutate: inviteConsultantMutation } = useMutation()
const { addSuccess, addError } = useNotification()



async function inviteConsultant() {
  inviteConsultantLoading.value = true

  await inviteConsultantMutation<
    InviteConsultantMutationMutation,
    InviteConsultantMutationMutationVariables
  >({
    mutation: InviteConsultantMutation,
    variables: {
      firstName: formData.value.firstName,
      lastName: formData.value.lastName,
      email: formData.value.email,
      jobTitleId: formData.value.jobTitleId?.prn,
    } as InviteConsultantMutationMutationVariables,
    onSuccess: () => {
      resetForm()
      emit("close")
      addSuccess("Consultant invited successfully")
    },
    onMutationError: (error) => {
      addError(error.message)
    },
  })

  inviteConsultantLoading.value = false
}

const resetForm = () => {
  formData.value = { ...defaultFormData }
}

return { __sfc: true,defaultFormData, formData, inviteConsultantLoading, inviteConsultantMutation, addSuccess, addError, emit, inviteConsultant, resetForm, OutlinedTextField, JobRoleSelect }
}

})